import React, {Component} from "react";
import _ from 'lodash';
import Loading from "../../loading";

class ConagoModal extends Component {
	render() {
		let {conclusion, conagoClauses, closeModal, fetching, selectedConago, selectedGoal} = this.props;
		console.log('GOAL =====> ', selectedGoal);
		return (
			<div className={`modal${this.props.active ? ' is-active' : ''}`}>
				<div className="modal-background" onClick={() => closeModal()}/>
				<div className="modal-content">
					<div className="message">
						<div className="message-header">
							<p>Seleccione las metas que aplican</p>
							<button type="button" onClick={() => closeModal()} className="delete is-medium" aria-label="delete"></button>
						</div>
						<div className="message-body">
							{fetching ? <Loading message="Cargando Metas CONAGO..."/> :
								<div className="field is-grouped is-grouped-multiline conago-checkboxes">
									{_.map(conagoClauses, (conago, k) => {
										let selectedIndex = undefined;
										let shouldCheck = _.findKey(selectedConago, (o, sel) => {
											if(o.id === conago.id) {
												selectedIndex = sel;
												return true;
											}
										}) !== undefined ? true : false;
										return (
											<div className="control" key={k}>
												<label htmlFor={`conago-${conago.id}`} className="checkbox" disabled={conclusion}>
													<input
														id={`conago-${conago.id}`}
														ref={`g-conago-${conago.id}`}
														value={conago.id}
														type="checkbox"
														checked={shouldCheck}
														className="checkbox"
														onChange={() => this._saveConago(conago.id, conago, selectedIndex)}
														disabled={conclusion}/>
													{conago.name}
												</label>
											</div>
										)
									})}
								</div>
							}

							<br/><br/>
							<div className="field is-grouped is-grouped-right">
								<div className="control">
									<button className="button is-info" type="button" onClick={() => this.props.closeModal}>Cerrar
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}

	_saveConago(id, conago, index) {
		if (this.refs[`g-conago-${id}`].checked) {
			this.props.add(`project.registry.data.project_goals[${this.props.selectedGoal}].conago_clauses`, conago);
		} else {
			console.log('INDEX OF CONAGO ====>', index);
			this.props.remove(`project.registry.data.project_goals[${this.props.selectedGoal}].conago_clauses`, index);
		}
	}
}

export default ConagoModal;


// WEBPACK FOOTER //
// ./src/elements/project/widgets/project_conago_modal_widget.jsx